<template>
  <div class="bg-nav">
    <!-- NAVBAR -->
    <div>
      <Navbar />
    </div>
    <div
      class="flex flex-col bg-products-cot container !h-auto mt-20 md:mt-0 mb-12"
    >
      <h1 class="font-crimson_pro font-bold text-3xl text-theme-9">
        Carrito de cotizaciones
      </h1>
      <div
        v-if="cart && cart?.quotations?.length"
        class="flex flex-col md:flex-row md:justify-between md:space-x-8"
      >
        <div class="flex flex-col md:w-2/3">
          <button
            class="flex self-end justify-center text-sm font-medium text-theme-6 hover:underline w-24"
            type="button"
            @click="handleOnDeleteQuotation(undefined)"
          >
            Eliminar todo
          </button>
          <div v-if="quotations?.length" class="flex flex-col">
            <p
              class="flex items-center p-2 h-[50px] rounded-lg bg-theme-1 text-white font-bold"
            >
              Cotizaciones normales
            </p>
            <div
              v-for="(quotation, index) in quotations"
              :key="index"
              class="flex flex-col rounded-[20px] bg-white/[29%] my-2 p-2 border-b-[3px] border-white/[28%]"
            >
              <div class="flex flex-col">
                <div class="flex flex-col md:flex-row">
                  <div
                    class="flex flex-row justify-between md:justify-start md:items-center px-4 md:w-1/2 md:space-x-4"
                  >
                    <div class="intro-x w-14 h-14 image-fit">
                      <img
                        alt="product"
                        style="box-shadow: 0 0 0 !important"
                        :src="
                          quotation?.product?.image?.length
                            ? quotation?.product?.image[0]
                            : require(quotation?.product?.sku !== 'COTESPI001'
                                ? '@/assets/images/product.svg'
                                : '@/assets/images/COTESPI001.svg')
                        "
                      />
                    </div>
                    <div class="flex flex-col space-y-1">
                      <p class="text-base">{{ quotation?.product?.name }}</p>
                      <p class="text-xs text-gray-600">
                        SKU: {{ quotation?.product?.sku }}
                      </p>
                      <div class="flex flex-row items-center text-xs space-x-1">
                        <p class="text-gray-600">P/U:</p>
                        <b>{{
                          newBasePrice(quotation)
                            ? formatter.format(newBasePrice(quotation)) + ' MXN'
                            : '-'
                        }}</b>
                        <p
                          v-if="
                            formatter.format(newBasePrice(quotation)) !=
                            formatter.format(basePrice(quotation))
                          "
                          class="text[10px] line-through"
                        >
                          {{
                            basePrice(quotation)
                              ? formatter.format(basePrice(quotation)) + ' MXN'
                              : '-'
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="flex md:hidden">
                      <button
                        class="text-theme-6 hover:text-white hover:bg-theme-6 rounded w-7 h-7"
                        type="button"
                        @click="handleOnDeleteQuotation(quotation)"
                      >
                        <Trash2Icon />
                      </button>
                    </div>
                  </div>
                  <div
                    class="flex flex-row items-center justify-between md:px-4 md:w-1/2"
                  >
                    <div class="flex flex-col items-center justify-center">
                      <p>Volumen de venta</p>
                      <p class="text-xs font-semibold">
                        {{
                          numberFormatter.format(
                            quotation.historic_prices[0].units
                          )
                        }}
                        pzs.
                      </p>
                    </div>
                    <div class="flex flex-col items-center justify-center">
                      <p>Cotización final</p>
                      <p class="text-base font-bold text-theme-33">
                        {{
                          quotation.historic_prices.length
                            ? formatter.format(finalPrice(quotation)) + ' MXN'
                            : '-'
                        }}
                      </p>
                    </div>
                    <div class="hidden md:flex">
                      <button
                        class="text-theme-6 hover:text-white hover:bg-theme-6 rounded w-7 h-7"
                        type="button"
                        @click="handleOnDeleteQuotation(quotation)"
                      >
                        <Trash2Icon />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="flex justify-center space-x-5 text-theme-6">
                  <button
                    @click="handleOnOpenQuotation(`detailsQ-${index}`)"
                    :id="`detailsQ-${index}`"
                    type="button"
                    class="hover:underline"
                  >
                    <p>Ver detalle</p>
                  </button>
                  <router-link
                    v-slot="{}"
                    :to="{
                      name: 'products',
                      params: { id: quotation.product_id },
                      query: { quotationId: quotation.id }
                    }"
                    class="text-center sm:text-left"
                  >
                    <p class="hover:underline">Editar cotización</p>
                  </router-link>
                </div>
                <div :id="`detailContentQ${index}`" class="hidden flex-col">
                  <hr class="h-2" />
                  <div class="flex md:flex-row flex-col">
                    <div class="flex flex-col w-full md:w-1/2 space-y-2">
                      <div class="flex flex-row space-x-1 items-center">
                        <p>No. de cajas master:</p>
                        <b>{{ quotation.custom_total_master_boxes }}</b>
                      </div>
                      <div class="flex flex-row space-x-1 items-center">
                        <p>Color:</p>
                        <p
                          class="h-4 w-4 rounded-full"
                          :style="{ backgroundColor: quotation.color }"
                        />
                      </div>
                      <div class="flex flex-row space-x-1 items-center">
                        <p>Tipo de personalización:</p>
                        <b>{{ quotation?.print_type?.name }}</b>
                      </div>
                      <div class="flex flex-row space-x-1 items-center">
                        <p>Tintas de impresión:</p>
                        <b>{{ quotation.max_number_inks }}</b>
                      </div>
                    </div>
                    <div class="flex flex-col w-full md:w-1/2 space-y-2">
                      <div class="flex flex-row space-x-1 items-center">
                        <p>Tiempos de entrega:</p>
                        <b
                          >{{
                            quotation.custom_days_approx_customization +
                            quotation.custom_days_approx_delivery
                          }}
                          días</b
                        >
                      </div>
                      <div class="flex flex-row space-x-1 items-center">
                        <p>No. de logos a imprimir:</p>
                        <b>{{
                          `1 logo a ${quotation.max_number_inks} tinta${
                            !isNaN(quotation.max_number_inks) &&
                            Number(quotation.max_number_inks) > 1
                              ? 's'
                              : ''
                          }`
                        }}</b>
                      </div>
                      <div
                        v-if="quotation.file"
                        class="flex flex-row space-x-1 items-center"
                      >
                        <p>Archivo de distribuición:</p>
                        <p class="text-theme-13 hover:underline">
                          <a
                            :href="quotation.file"
                            download
                            target="_blank"
                            rel="noreferrer"
                            class="font-bold"
                          >
                            <PaperclipIcon class="h-[16px]" />
                            Descargar Archivo
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="quotationsSpecial?.length" class="flex flex-col">
            <p
              class="flex items-center p-2 h-[50px] rounded-lg bg-theme-1 text-white font-bold"
            >
              Cotizaciones especiales
            </p>
            <div
              v-for="(quotation, index) in quotationsSpecial"
              :key="index"
              class="flex flex-col rounded-[20px] bg-white/[29%] my-2 p-2 border-b-[3px] border-white/[28%]"
            >
              <div
                v-if="quotation.product.sku === 'COTESPI001'"
                class="flex flex-col"
              >
                <div class="flex flex-col md:flex-row">
                  <div
                    class="flex flex-row justify-between md:justify-start md:items-center px-4 md:w-1/2 md:space-x-4"
                  >
                    <div class="intro-x w-14 h-14 image-fit">
                      <img
                        alt="product"
                        style="box-shadow: 0 0 0 !important"
                        :src="
                          quotation?.product?.image?.length
                            ? quotation?.product?.image[0]
                            : require(quotation?.product?.sku !== 'COTESPI001'
                                ? '@/assets/images/product.svg'
                                : '@/assets/images/COTESPI001.svg')
                        "
                      />
                    </div>
                    <div class="flex flex-col space-y-1">
                      <p class="text-base">Cotización especial</p>
                    </div>
                    <div class="flex md:hidden">
                      <button
                        class="text-theme-6 hover:text-white hover:bg-theme-6 rounded w-7 h-7"
                        type="button"
                        @click="handleOnDeleteQuotation(quotation)"
                      >
                        <Trash2Icon />
                      </button>
                    </div>
                  </div>
                  <div
                    class="flex flex-row items-center justify-between md:px-4 md:w-1/2"
                  >
                    <div class="flex flex-col items-center justify-center">
                      <p>Volumen de venta</p>
                      <p class="text-xs font-semibold">
                        {{
                          numberFormatter.format(
                            quotation.historic_prices[0].units
                          )
                        }}
                        pzs.
                      </p>
                    </div>
                    <div class="hidden md:flex">
                      <button
                        class="text-theme-6 hover:text-white hover:bg-theme-6 rounded w-7 h-7"
                        type="button"
                        @click="handleOnDeleteQuotation(quotation)"
                      >
                        <Trash2Icon />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="flex justify-center space-x-5 text-theme-6">
                  <button
                    @click="
                      handleOnOpenQuotation(
                        `detailsQS-${index}`,
                        'detailContentQS'
                      )
                    "
                    :id="`detailsQS-${index}`"
                    type="button"
                    class="hover:underline"
                  >
                    <p>Ver detalle</p>
                  </button>
                  <router-link
                    v-slot="{}"
                    :to="{
                      name: 'products',
                      params: { id: quotation.product_id },
                      query: { quotationId: quotation.id }
                    }"
                    class="text-center sm:text-left"
                  >
                    <p class="hover:underline">Editar cotización</p>
                  </router-link>
                </div>
                <div :id="`detailContentQS${index}`" class="hidden flex-col">
                  <hr class="h-2" />
                  <div class="flex flex-col space-y-2">
                    <div class="flex flex-col">
                      <p>Requerimientos:</p>
                      <b>{{ quotation.additional_requirements }}</b>
                    </div>
                    <div
                      v-if="quotation.file"
                      class="flex flex-row space-x-1 items-center"
                    >
                      <p>Archivo de distribuición:</p>
                      <p class="text-theme-13 hover:underline">
                        <a
                          :href="quotation.file"
                          download
                          target="_blank"
                          rel="noreferrer"
                          class="font-bold"
                        >
                          <PaperclipIcon class="h-[16px]" />
                          Descargar Archivo
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="flex flex-col">
                <div class="flex flex-col md:flex-row">
                  <div
                    class="flex flex-row justify-between md:justify-start md:items-center px-4 md:w-1/2 md:space-x-4"
                  >
                    <div class="intro-x w-14 h-14 image-fit">
                      <img
                        alt="product"
                        style="box-shadow: 0 0 0 !important"
                        :src="
                          quotation?.product?.image?.length
                            ? quotation?.product?.image[0]
                            : require(quotation?.product?.sku !== 'COTESPI001'
                                ? '@/assets/images/product.svg'
                                : '@/assets/images/COTESPI001.svg')
                        "
                      />
                    </div>
                    <div class="flex flex-col space-y-1">
                      <p class="text-base">{{ quotation?.product?.name }}</p>
                      <p class="text-xs text-gray-600">
                        SKU: {{ quotation?.product?.sku }}
                      </p>
                      <div class="flex flex-row items-center text-xs space-x-1">
                        <p class="text-gray-600">P/U:</p>
                        <b>{{
                          newBasePrice(quotation)
                            ? formatter.format(newBasePrice(quotation)) + ' MXN'
                            : '-'
                        }}</b>
                        <p
                          v-if="
                            formatter.format(newBasePrice(quotation)) !=
                            formatter.format(basePrice(quotation))
                          "
                          class="text[10px] line-through"
                        >
                          {{
                            basePrice(quotation)
                              ? formatter.format(basePrice(quotation)) + ' MXN'
                              : '-'
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="flex md:hidden">
                      <button
                        class="text-theme-6 hover:text-white hover:bg-theme-6 rounded w-7 h-7"
                        type="button"
                        @click="handleOnDeleteQuotation(quotation)"
                      >
                        <Trash2Icon />
                      </button>
                    </div>
                  </div>
                  <div
                    class="flex flex-row items-center justify-between md:px-4 md:w-1/2"
                  >
                    <div class="flex flex-col items-center justify-center">
                      <p>Volumen de venta</p>
                      <p class="text-xs font-semibold">
                        {{
                          numberFormatter.format(
                            quotation.historic_prices[0].units
                          )
                        }}
                        pzs.
                      </p>
                    </div>
                    <div class="flex flex-col items-center justify-center">
                      <p>Cotización final</p>
                      <p class="text-base font-bold text-theme-33">
                        {{
                          quotation.historic_prices.length
                            ? formatter.format(finalPrice(quotation)) + ' MXN'
                            : '-'
                        }}
                      </p>
                    </div>
                    <div class="hidden md:flex">
                      <button
                        class="text-theme-6 hover:text-white hover:bg-theme-6 rounded w-7 h-7"
                        type="button"
                        @click="handleOnDeleteQuotation(quotation)"
                      >
                        <Trash2Icon />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="flex justify-center space-x-5 text-theme-6">
                  <button
                    @click="
                      handleOnOpenQuotation(
                        `detailsQS-${index}`,
                        'detailContentQS'
                      )
                    "
                    :id="`detailsQS-${index}`"
                    type="button"
                    class="hover:underline"
                  >
                    <p>Ver detalle</p>
                  </button>
                  <router-link
                    v-slot="{}"
                    :to="{
                      name: 'products',
                      params: { id: quotation.product_id },
                      query: { quotationId: quotation.id }
                    }"
                    class="text-center sm:text-left"
                  >
                    <p class="hover:underline">Editar cotización</p>
                  </router-link>
                </div>
                <div :id="`detailContentQS${index}`" class="hidden flex-col">
                  <hr class="h-2" />
                  <div class="flex md:flex-row flex-col">
                    <div class="flex flex-col w-full md:w-1/2 space-y-2">
                      <div class="flex flex-row space-x-1 items-center">
                        <p>No. de cajas master:</p>
                        <b>{{ quotation.custom_total_master_boxes }}</b>
                      </div>
                      <div class="flex flex-row space-x-1 items-center">
                        <p>Color:</p>
                        <p
                          class="h-4 w-4 rounded-full"
                          :style="{ backgroundColor: quotation.color }"
                        />
                      </div>
                      <div class="flex flex-row space-x-1 items-center">
                        <p>Tipo de personalización:</p>
                        <b>{{ quotation?.print_type?.name }}</b>
                      </div>
                      <div class="flex flex-row space-x-1 items-center">
                        <p>Tintas de impresión:</p>
                        <b>{{ quotation.max_number_inks }}</b>
                      </div>
                    </div>
                    <div class="flex flex-col w-full md:w-1/2 space-y-2">
                      <div class="flex flex-row space-x-1 items-center">
                        <p>Tiempos de entrega:</p>
                        <b
                          >{{
                            quotation.custom_days_approx_customization +
                            quotation.custom_days_approx_delivery
                          }}
                          días</b
                        >
                      </div>
                      <div class="flex flex-row space-x-1 items-center">
                        <p>No. de logos a imprimir:</p>
                        <b>{{
                          `1 logo a ${quotation.max_number_inks} tinta${
                            !isNaN(quotation.max_number_inks) &&
                            Number(quotation.max_number_inks) > 1
                              ? 's'
                              : ''
                          }`
                        }}</b>
                      </div>
                      <div
                        v-if="quotation.file"
                        class="flex flex-row space-x-1 items-center"
                      >
                        <p>Archivo de distribuición:</p>
                        <p class="text-theme-13 hover:underline">
                          <a
                            :href="quotation.file"
                            download
                            target="_blank"
                            rel="noreferrer"
                            class="font-bold"
                          >
                            <PaperclipIcon class="h-[16px]" />
                            Descargar Archivo
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col mt-2">
                    <p>Descripción:</p>
                    <b>{{ quotation.additional_requirements }}</b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col md:w-1/3">
          <div
            class="flex flex-col rounded-lg bg-white/30 border-white border-[3px] p-4 space-y-2 font-poppins"
          >
            <p class="text-3xl font-bold font-crimson_pro text-center">
              Resumen
            </p>
            <div
              class="flex flex-row justify-between items-center border-b py-2"
            >
              <p>Fecha de solicitud:</p>
              <b>{{
                new Date().toLocaleDateString('es-Mx', {
                  day: '2-digit',
                  month: '2-digit',
                  year: '2-digit'
                })
              }}</b>
            </div>
            <div
              class="flex flex-row justify-between items-center border-b py-2"
            >
              <p>Cotizaciones normales:</p>
              <b>{{ quotations?.length }}</b>
            </div>
            <div
              class="flex flex-row justify-between items-center border-b py-2"
            >
              <p>Cotizaciones especiales:</p>
              <b>{{ quotationsSpecial?.length }}</b>
            </div>
            <div
              class="flex flex-row justify-between items-center border-b py-2"
            >
              <p>Total:</p>
              <b class="text-[#005CB4]">{{
                formatter.format(
                  quotationsAll.reduce(
                    (total, quotation) =>
                      Number(total) + Number(finalPrice(quotation)),
                    0
                  )
                )
              }}</b>
            </div>
            <div class="flex justify-center py-4">
              <button
                type="button"
                class="m-auto sm:m-0 h-12 w-60 rounded text-white hover:scale-110 btn-deg font-poppins"
                @click="handleOnClick"
              >
                Solicitar cotización
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="flex flex-col justify-center items-center space-y-4">
        <div class="max-w-[200px] max-h-[200px]">
          <img
            :src="require('@/assets/images/cart/empty-cart.png')"
            alt="empty"
          />
        </div>
        <p>Aún no has agregado cotizaciones</p>
      </div>
      <div v-if="releatedProducts?.length > 0" class="container mx-auto my-4">
        <div>
          <h1 class="font-crimson_pro font-bold text-3xl text-theme-9 my-8">
            Productos relacionados
          </h1>
        </div>
        <div class="grid grid-cols-12 gap-4 mb-6">
          <div class="sm:col-span-9 col-span-12">
            <div class="grid sm:grid-cols-3 grid-cols-2 gap-4">
              <div
                class="b-cot-card min-h-[288px] p-4 sm:max-w-[192px] md:max-w-[296px] w-full cursor-pointer"
                style="background-color: #f4f4f45c"
                v-for="product in releatedProducts"
                :key="product.id"
                :title="product.name"
              >
                <div class="grid grid-cols-4 gap-4">
                  <div class="col-span-3" @click="goToProduct(product)">
                    <h1 class="text-theme-9 font-poppins font-medium truncate">
                      {{ product.name }}
                    </h1>
                  </div>
                  <div>
                    <span @click="changeFavoriteProduct(product.id)">
                      <heartIcon
                        :class="{
                          'text-transparent': !product?.users_favorite?.length,
                          'text-theme-9': product?.users_favorite?.length
                        }"
                        class="font-poppins font-medium fill-current"
                        :style="{
                          stroke: !product?.users_favorite?.length
                            ? '#a13122'
                            : 'currentColor'
                        }"
                      />
                    </span>
                  </div>
                </div>
                <div
                  class="w-44 h-40 mx-auto my-4"
                  style="background: #ffffff7a; border-radius: 24px"
                  @click="goToProduct(product)"
                >
                  <img
                    :src="getProductImage(product)"
                    alt="Imagen del producto"
                    class="h-40 object-contain m-auto rounded"
                    crossorigin="anonymous"
                  />
                </div>
                <div
                  class="grid grid-cols-2 gap-4"
                  @click="goToProduct(product)"
                >
                  <div class="text-xs font-poppins">
                    Mínimo
                    {{
                      product?.customizations?.length
                        ? (
                            product.customizations
                              .map((c) => c.sale_volume)
                              .sort(
                                (a, b) => a.minimum_units - b.minimum_units
                              )[0].minimum_units || 0
                          ).toLocaleString()
                        : 0
                    }}
                    pzas
                  </div>
                  <div class="text-xs font-poppins">
                    Desde
                    {{
                      formatter.format(
                        product?.customizations?.sort(
                          (a, b) => a.base_price - b.base_price
                        )[0]?.base_price || 0
                      )
                    }}
                    MXN
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      tabindex="-1"
      aria-hidden="true"
      data-backdrop="static"
      ref="noticeDeleteQuotationModal"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content rounded-xl">
          <div class="modal-body">
            <p
              class="text-[#CE0100] text-center font-bold text-3xl font-crimson_pro"
            >
              Aviso
            </p>
            <p v-if="!all" class="font-poppins text-center pt-4">
              ¿Quieres eliminar este producto de tu carrito?
            </p>
            <p v-else class="font-poppins text-center pt-4">
              ¿Quieres eliminar todos los productos de tu carrito?
            </p>
          </div>
          <div class="modal-footer px-10 border-0">
            <div class="flex flex-col justify-center items-center space-y-2">
              <button
                type="button"
                class="btn btn-quotation rounded-lg w-full sm:w-2/4 text-base"
                @click="deleteQuotation"
              >
                Eliminar
              </button>
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-quotation-outline rounded-lg w-full sm:w-2/4 text-base"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      tabindex="-1"
      aria-hidden="true"
      data-backdrop="static"
      ref="noticeSuccessQuotationModal"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content rounded-xl">
          <div class="modal-body">
            <div
              class="max-w-[200px] max-h-[200px] flex justify-center items-center mx-auto"
            >
              <img
                :src="require('@/assets/images/cart/success.png')"
                alt="empty"
              />
            </div>
            <p
              class="text-[#CE0100] text-center font-bold text-3xl font-crimson_pro"
            >
              ¡Tus cotizaciones fueron enviadas con éxito! 🎉
            </p>
            <p class="font-poppins text-center pt-4">
              Un operador se pondrá en contacto contigo vía correo electrónico
              para dar seguimiento a tus solicitudes, incluidas las cotizaciones
              especiales.
            </p>
          </div>
          <div class="modal-footer px-10 border-0">
            <div class="flex flex-col justify-center items-center space-y-2">
              <router-link
                v-slot="{}"
                :to="{ name: 'catalogue' }"
                class="text-center sm:text-left"
              >
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-quotation rounded-lg w-[250px] h-14 text-base"
                >
                  Volver al catálogo
                </button>
              </router-link>
              <router-link
                v-slot="{}"
                :to="{ name: 'quotations' }"
                class="text-center sm:text-left"
              >
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-quotation rounded-lg w-[250px] h-14 text-base"
                >
                  Ir a mis cotizaciones
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <Footer />
    </div>
  </div>
</template>
<script>
import Navbar from '@/components/navbar/Main.vue'
import Footer from '@/components/footer/Main.vue'
import { formatter, numberFormatter } from '@/utils/tools'
import { mapGetters } from 'vuex'
export default {
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    formatter: formatter,
    numberFormatter: numberFormatter,
    currentQuotation: null,
    all: false
  }),
  computed: {
    ...mapGetters({
      cart: 'cart/getCart',
      quotationsAll: 'cart/getQuotationsAll',
      quotations: 'cart/getQuotations',
      quotationsSpecial: 'cart/getQuotationsSpecial',
      company: 'auth/getCompany',
      releatedProducts: 'cart/getProductsInterests'
    })
  },
  methods: {
    getProductImage(product) {
      return Array.isArray(product.image) && product.image.length
        ? product.image[0]
        : require(product.sku !== 'COTESPI001'
            ? '@/assets/images/product.svg'
            : '@/assets/images/COTESPI001.svg')
    },
    goToProduct(product) {
      this.$router.push({ name: 'products', params: { id: product.id } })
    },
    basePrice(quotation) {
      const historicPrices = quotation?.historic_prices?.length
        ? quotation.historic_prices[0]
        : undefined
      if (historicPrices == undefined) return 0

      let indirect = 1
      let utility = 1
      if (historicPrices.historic_percentage_indirect_expenses) {
        indirect =
          1 - historicPrices.historic_percentage_indirect_expenses / 100
        utility = historicPrices.historic_percentage_utility
          ? 1 - historicPrices.historic_percentage_utility / 100
          : 1
      }

      const basePrice = Number(historicPrices.historic_base_price)
      const packagingPrice =
        Number(basePrice) / Number(indirect) - Number(basePrice)

      const subtotal = Number(
        basePrice +
          packagingPrice +
          Number(historicPrices.historic_cost_per_impression)
      )

      return Number(subtotal / utility).toFixed(2)
    },
    newBasePrice(quotation) {
      const historicPrices = quotation?.historic_prices?.length
        ? quotation.historic_prices[0]
        : undefined
      if (historicPrices == undefined) return 0

      const saleVolume = quotation.customizations
      const saleVolumeWithCost = saleVolume?.base_price || 0

      if (saleVolume && saleVolumeWithCost) {
        let indirect = 1
        let utility = 1
        if (this.company?.percentage_indirect_expenses) {
          indirect = 1 - this.company.percentage_indirect_expenses / 100
          utility = this.company.percentage_utility
            ? 1 - this.company.percentage_utility / 100
            : 1
        }

        const basePrice = Number(saleVolumeWithCost)
        const packagingPrice =
          Number(basePrice) / Number(indirect) - Number(basePrice)

        const subtotal = Number(
          basePrice +
            packagingPrice +
            Number(historicPrices.historic_cost_per_impression)
        )

        return Number(subtotal / utility)
      } else {
        return 0
      }
    },
    finalPrice(quotation) {
      const historicPrices = quotation?.historic_prices?.length
        ? quotation.historic_prices[0]
        : undefined
      if (historicPrices == undefined) return 0

      return Number(historicPrices.units) * Number(this.newBasePrice(quotation))
    },
    handleOnOpenQuotation(buttonId, contentId = 'detailContentQ') {
      const e = document.getElementById(buttonId)
      const id = e.getAttribute('id').split('-')[1]
      const elementContent = document.getElementById(`${contentId}${id}`)
      if (elementContent.classList.contains('flex')) {
        e.children[0].textContent = 'Ver detalle'
        elementContent.classList.add('hidden')
        elementContent.classList.remove('flex')
      } else {
        e.children[0].textContent = 'Ocultar detalle'
        elementContent.classList.add('flex')
        elementContent.classList.remove('hidden')
      }
    },
    handleOnDeleteQuotation(quotation = undefined) {
      this.all = quotation == undefined
      this.currentQuotation = quotation

      const modal = this.$refs.noticeDeleteQuotationModal
      cash(modal).modal('show')
    },
    async deleteQuotation() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        if (!this.all) {
          const response = await this.axios.post(
            'sales-operator/cart/delete',
            {
              quotation_id: this.currentQuotation.id
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            }
          )
          if (response?.data?.multi_quotation) {
            this.$store.commit(
              'cart/setCartData',
              response.data.multi_quotation
            )
            this.$store.commit(
              'cart/setCountQuotations',
              response.data.multi_quotation.quotations.length
            )
            this.$store.commit(
              'cart/setProductsInterests',
              response.data.product_interests
            )
          } else {
            this.$store.commit('cart/setCartData')
            this.$store.commit('cart/setCountQuotations', 0)
            this.$store.commit('cart/setProductsInterests', [])
          }
          this.$toast.success('El producto ha sido eliminado correctamente', {
            position: 'top'
          })
        } else {
          await this.axios.delete('sales-operator/cart/destroy', {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          })
          this.$store.commit('cart/setCartData')
          this.$store.commit('cart/setCountQuotations', 0)
          this.$store.commit('cart/setProductsInterests', [])
          this.$toast.success(
            'Todos los productos han sido eliminados de tu carrito.',
            {
              position: 'top'
            }
          )
        }
      } catch {
        this.$store.commit('cart/setCartData')
        this.$store.commit('cart/setCountQuotations', 0)
        this.$store.commit('cart/setProductsInterests', [])
      }
      const modal = this.$refs.noticeDeleteQuotationModal
      cash(modal).modal('hide')
      this.$store.commit('main/setShowSpinner', false)
    },
    async handleOnClick() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post(
          'sales-operator/cart/finish',
          {},
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        this.$store.commit('cart/setCartData')
        this.$store.commit('cart/setCountQuotations', 0)
        this.$store.commit('cart/setProductsInterests', [])
        const modal = this.$refs.noticeSuccessQuotationModal
        cash(modal).modal('show')
      } catch (error) {
        console.log(error.response.data)
        this.$toast.error('Error al finalizar el carrito, intente más tarde.', {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async getCart() {
      this.$store.commit('main/setShowSpinner', true)
      const response = await this.axios.get('sales-operator/cart', {
        headers: {
          Authorization: `Bearer ${this.$store.state.auth.token}`,
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json'
        }
      })
      this.$store.commit(
        'cart/setCountQuotations',
        response?.data?.multi_quotation?.quotations?.length || 0
      )

      this.$store.commit(
        'cart/setCartData',
        response?.data?.multi_quotation || []
      )

      this.$store.commit('main/setShowSpinner', false)
    },
    async getProductsInterests() {
      this.$store.commit('main/setShowSpinner', true)
      const response = await this.axios.get(
        'sales-operator/cart/products-interests',
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`,
            'Content-Type': 'multipart/form-data',
            Accept: 'application/json'
          },
          params: {
            product_ids:
              this.cart?.quotations?.map((product) => product.product_id) || []
          }
        }
      )
      this.$store.commit('cart/setProductsInterests', response?.data || [])
      this.$store.commit('main/setShowSpinner', false)
    }
  },
  async created() {
    if (!this.cart) {
      await this.getCart()
    }
    await this.getProductsInterests()
  }
}
</script>
<style scoped>
.bg-products-cot {
  background: url('@/assets/images/COT-bg/img-products.svg');
  background-repeat: no-repeat;
  background-position: inherit;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 230px;
  width: auto;
  padding-top: 2px;
}
</style>
